module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "loader",
    class: {
      active: !_vm.isReady
    }
  }), _vm._v(" "), _c('div', {
    class: {
      active: _vm.isReady
    },
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "id": "my-router-view"
    }
  })], 1), _vm._v(" "), _c('footbar'), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rotate-warning"
    }
  }, [_c('div', {
    attrs: {
      "id": "rotate-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "rotate-sprite"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Please rotate your device")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4609b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 142
// module chunks = 2